<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalgridLabel">{{'heading-title.add-wallet-amount' | translate}}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="row gy-3 mb-3">
          <div class="col-md-12 mt-0">
            <input type="phone" class="form-control" formControlName="amount" (input)="validateNumberInput($event)"
              (keydown)="helper.spaceValidation($event)" placeholder="{{'label-title.enter-amount' | translate}}">
          </div>
          @if (amountInput?.invalid && amountInput?.touched) {
          <div class="invalid-message">
            @if (amountInput?.hasError('required')) {
            <span>{{ 'label-title.amount' | translate | titlecase }} {{'label-title.is-required' | translate}}</span>
            } @else if (amountInput?.hasError('minValue')) {
            <span>{{ "validation-title.number-greater-than-zero" | translate }}</span>
            }
          </div>
          }
        </div>
        <div class="d-flex justify-content-end">
          <button id="update-city-boundry"
            class="btn btn-sm btn-secondary btn-load d-flex align-items-center justify-content-center"
            style="overflow: unset;" (click)="submit()"><span class="d-flex align-items-center">
              <span class="flex-grow-1">{{'button-title.add' | translate | titlecase}}</span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>